var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons"},_vm._l((_vm.getValues),function(item,index){return _c('span',{key:index,staticClass:"btn"},[_vm._v("\n    "+_vm._s(item.value)+" "+_vm._s(_vm.getWord(index))+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-839aaeb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IMTable/components/tdBox/components/timeRange/index.vue
// module id = null
// module chunks = 